<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        busiTypeOptions: [], // 卡类型
        oilRechargeBillTypeOptions: [], // 油类型
        form: [
          { // 时间
            label: '时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 银行账户
            label: '银行账户',
            value: 'acctNameOrNo',
            type: 'input',
            placeholder: '请输入银行账户',
          },
          { // 油类型
            label: '油类型',
            value: 'oilRechargeBillType',
            type: 'select',
            default: -1,
            placeholder: '请输入油类型',
          },
          { // 业务类型
            label: '业务类型',
            value: 'busiType',
            type: 'select',
            default: -1,
            placeholder: '请输入业务类型',
          },
          { // 业务单号
            label: '业务单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入业务单号',
          },
          { // 订单号
            label: '订单号',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号',
          },
          { // 车牌号
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          { // 对方账户
            label: '对方账户',
            value: 'relationPhone',
            type: 'input',
            placeholder: '请输入对方账户',
          },
          { // 对方名称
            label: '对方名称',
            value: 'relationName',
            type: 'input',
            placeholder: '请输入对方名称',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.Time[0]) { // 消费时间
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
      }
      delete searchBoxData.Time;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'OIL_RECHARGE_LIST_SOURCE_TYPE,OIL_RECHARGE_BUSI_TYPE',
    });
    this.searchBoxData.oilRechargeBillTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.busiTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
